module.exports = __webpack_public_path__ + "static/media/Close-1.4b341648.JPG";